// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","researchItem":"_6pk7gNF0vwaZ7QVgtqBO9","narrow":"_1wkAr--dP1sbxuj8ZWFWe3"};